import { observer, useLocalObservable } from "mobx-react"
import { Flex, Table } from "antd"
import { choose } from "choose-matching"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { CryptoPayoutsCollection } from "@src/pages/transactionsOut/classes/CryptoPayoutsCollection"
import {
  TransactionsOutColumns,
  TransactionsOutDetails,
  TransactionsOutEmpty,
} from "@src/pages/transactionsOut/constants"
import { TableFilters } from "@src/shared/componemts/TableFilter"

export const TransactionsOutPage = observer(() => {
  const payouts = useLocalObservable(() => new CryptoPayoutsCollection())

  return (
    <Flex gap={16} vertical>
      <TableFilters {...payouts.filter.props} />
      {choose(
        [payouts.isLoading && payouts.isEmpty, <LoadingBlock />],
        [payouts.isEmpty, <TransactionsOutEmpty />],
        [
          !payouts.isEmpty,
          <Table
            columns={TransactionsOutColumns}
            dataSource={payouts.items}
            expandable={{
              expandedRowRender: (record) => (
                <TransactionsOutDetails payout={record} />
              ),
            }}
            loading={payouts.isLoading}
            pagination={payouts.pagination}
            rowKey="id"
            scroll={{ x: true }}
            style={{ width: "100%" }}
          />,
        ],
      )}
    </Flex>
  )
})
